import { getFrameName, handleIntegrationIframeMessage, postObjectChangeToFrame } from 'App/helpers/uiElementsHelper';
import React, { useCallback, useEffect, useRef } from 'react';

export default function IFrameRenderType({ row, config, type, object, utils }) {
	const iframeRef = useRef();
	var iframeProps = {
		className: 'widget-iframe',
		sandbox: 'allow-scripts allow-downloads allow-popups',
		name: row.name
			? getFrameName({ ...config, name: row.name })
			: `ui-element-${config.integrationId}-${row.id || '0'}`,
		style: {},
		ref: iframeRef
	};

	if (row.url) {
		iframeProps.src = row.url;
	} else if (row.html) {
		iframeProps.srcDoc = row.html;
	}

	if (row.height && typeof row.height === 'number') {
		iframeProps.style.height = `${row.height}px`;
	}

	if (row.width && typeof row.width === 'number') {
		iframeProps.style.width = `${row.width}px`;
	}

	if (row.scrolling === false) {
		row.scrolling = 'no';
	}

	const onLoad = () => {
		postObjectChangeToFrame(config, object);

		if (config.source === 'n8n' && iframeRef.current && iframeRef.current.contentWindow) {
			const cleanedObject = object ? { ...object } : null;

			if (cleanedObject) {
				delete cleanedObject.client;
				delete cleanedObject.lastSuccess;
			}

			const messageData = {
				type: 'OBJECT_DATA',
				data: cleanedObject || null
			};

			if (type) {
				messageData.region = type;
			}

			iframeRef.current.contentWindow.postMessage(messageData, '*');
		}
	};

	const iframeMessage = useCallback(
		event => {
			// Only process messages from our own iframe
			if (event.source !== iframeRef.current?.contentWindow) {
				return;
			}
			handleIntegrationIframeMessage(type, config.integrationId, () => object, utils, event);
		},
		[type, config]
	);

	useEffect(() => {
		window.addEventListener('message', iframeMessage);
		return () => {
			window.removeEventListener('message', iframeMessage);
		};
	}, [iframeMessage]);

	useEffect(() => {
		postObjectChangeToFrame(config, object);
	}, [config, JSON.stringify(object)]);

	useEffect(() => {
		iframeRef.current?.addEventListener('load', onLoad);

		return () => {
			iframeRef.current?.removeEventListener('load');
		};
	}, []);

	iframeProps.scrolling = row.scrolling || 'auto';

	// row 95 to 101 in UiElements.js directive
	// hasnt been ported here yet.

	return <div className="widget-iframe-wrapper">{React.createElement('iframe', iframeProps)}</div>;
}
